import { NON_PARTNER_CAPS } from '../constants/nonPartnerCap';

/**
 * Non-partner earnings are capped, with the cap scaling by the number of core
 * services in the bundle. `NON_PARTNER_CAPS` is ordered highest-to-lowest
 * `minServices`, so the first match is the most generous cap the bundle
 * qualifies for. Falls back to the lowest cap if nothing matches.
 *
 * @param {number} coreServiceCount - number of core services in the bundle
 * @returns {number} max non-partner earnings, in pounds
 */
const getNonPartnerCap = (coreServiceCount: number): number =>
  NON_PARTNER_CAPS.find(({ minServices }) => coreServiceCount >= minServices)
    ?.maxEarnings ?? NON_PARTNER_CAPS[NON_PARTNER_CAPS.length - 1].maxEarnings;

export { getNonPartnerCap };
